class Util {
  getVideoHeight() {
    return (window.screen.width * 9) / 16
  }

  go(url) {
    console.log(url)
    if (url === undefined) {
      console.log('跳转地址不存在')
      return
    }
    window.location.href = url
  }

  px2Rem(px) {
    var htmlFontSize =
      document.body.currentStyle ||
      document.defaultView.getComputedStyle(document.body, '').fontSize
    let scale = 16 / htmlFontSize.replace('px', '')
    return px.replace('px', '') * scale + 'px'
  }

  keepScreenOn(on) {
    try {
      window.goods.keepScreenOn(on)
    } catch (e) {
      // console.log(e)
    }
  }

  closeFloatVideo() {
    try {
      window.goods &&
        window.goods.closeFloatVideo &&
        window.goods.closeFloatVideo('')
    } catch (e) {
      // console.log(e)
    }
  }

  compareMv(targetMv, currentMv, isIncludeEqual = true) {
    if (!targetMv) {
      console.warn('版本比对异常：请传入要比对的版本')
      return
    }

    if (typeof currentMv === 'boolean') {
      isIncludeEqual = currentMv
      currentMv = undefined
    }

    let isSupport = false
    currentMv = currentMv || this.mv

    if (targetMv === currentMv) {
      isSupport = isIncludeEqual
    } else {
      const targetMvArr = targetMv.split('.')
      const currentMvArr = currentMv.split('.')
      if (currentMvArr.length === targetMvArr.length) {
        for (let i = 0; i < currentMvArr.length; i++) {
          if (currentMvArr[i] !== targetMvArr[i]) {
            isSupport = +currentMvArr[i] > +targetMvArr[i]
            break
          }
        }
      } else {
        isSupport = currentMvArr.length > targetMvArr.length
      }
    }

    return isSupport
  }
}

export default new Util()
